import { createSlice } from '@reduxjs/toolkit';

export const productsSlice = createSlice({
    name: "products",
    initialState: [],
    reducers: {
        set: (state, action) => {
            state = action.payload;
            return state;
        }
    }
})

export const productsActions = productsSlice.actions;

export default productsSlice.reducer;